import { X } from "lucide-react";
import { useEffect } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ImageModal = ({ item, onClose }) => {
  const navigate = useNavigate();

  console.log(item.id.slice(0, -2));

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscape);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [onClose]);

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="modal-close-button">
          <X size={24} />
        </button>

        <div className="modal-layout">
          <div className="modal-image-section">
            <img src={item.image} alt={item.title} className="modal-image" />
          </div>

          <div className="modal-info-section">
            <h2 className="modal-title" data-tts="true">
              {item.title}
            </h2>
            <p className="modal-description" data-tts="true">
              {item.description}
            </p>

            <div className="modal-footer">
              <Button
                data-tts="true"
                variant="contained"
                onClick={() => navigate(`/posts/${item.id.slice(0, -2)}`)}
                className="modal-close-button-secondary"
              >
                Go to Post
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageModal;
